(() => {
  const storageKey = 'f24_geo_market_checked_v1';

  const markChecked = () => {
    try {
      window.sessionStorage.setItem(storageKey, '1');
    } catch (error) {
      // Storage can be unavailable in privacy-restricted browsers.
    }
  };

  const alreadyChecked = () => {
    try {
      return window.sessionStorage.getItem(storageKey) === '1';
    } catch (error) {
      return false;
    }
  };

  const switchCountry = (countryCode) => {
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = '/localization';
    form.hidden = true;

    const addField = (name, value) => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = value;
      form.appendChild(input);
    };

    addField('_method', 'PUT');
    addField('country_code', countryCode);
    addField('return_to', `${window.location.pathname}${window.location.search}${window.location.hash}`);

    document.body.appendChild(form);
    form.submit();
  };

  const detectAndApplyMarket = async () => {
    if (!window.Shopify || window.Shopify.designMode || alreadyChecked()) return;

    const path = window.location.pathname.replace(/\/+$/, '') || '/';
    if (path === '/cart' || path === '/checkout' || path.startsWith('/checkouts/')) {
      markChecked();
      return;
    }

    const config = window.F24GeoMarketConfig || {};
    const currentCountry = String(config.currentCountry || window.Shopify.country || '').toUpperCase();
    const availableCountries = new Set(
      Array.isArray(config.availableCountries)
        ? config.availableCountries.map((code) => String(code).toUpperCase())
        : []
    );

    try {
      const root = (window.Shopify.routes && window.Shopify.routes.root) || '/';
      const suggestionUrl = new URL(`${root}browsing_context_suggestions.json`, window.location.origin);
      suggestionUrl.searchParams.set('country[enabled]', 'true');
      if (currentCountry) suggestionUrl.searchParams.set('country[exclude]', currentCountry);

      const response = await fetch(suggestionUrl.toString(), {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      });

      if (!response.ok) {
        markChecked();
        return;
      }

      const data = await response.json();
      const suggestedCountry = data?.suggestions?.find((item) => item?.parts?.country?.handle)?.parts?.country?.handle;
      const detectedCountry = data?.detected_values?.country?.handle;
      const country = String(suggestedCountry || detectedCountry || '').toUpperCase();

      if (
        !country ||
        country === currentCountry ||
        (availableCountries.size > 0 && !availableCountries.has(country))
      ) {
        markChecked();
        return;
      }

      markChecked();
      switchCountry(country);
    } catch (error) {
      markChecked();
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', detectAndApplyMarket, { once: true });
  } else {
    detectAndApplyMarket();
  }
})();
